import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useBanking() {
    const api = useApi();
    const state = useAppState();
    function getBankingInfo(onSuccess = null, refreshCache = false, daysHistory = null) {
        const url = "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/Info?lite=false" + (daysHistory ? "&daysHistory=" + daysHistory : "");
        api.GET(url, (result) => {
            state.bankInfo = result;
            if (onSuccess)
                onSuccess();
        }, !refreshCache, refreshCache);
    }
    function clearBankingInfo() {
        const config = getApiConfig();
        localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/Info?lite=false');
    }
    function getBankAccount(id, onSuccess = null, lite = false, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + id + "?lite=" + lite + "&groupTransactions=true&limitTransactions=true", (result) => {
            state.bankAccount = result;
            if (onSuccess)
                onSuccess(result);
        }, !refreshCache, refreshCache);
    }
    function listBanks(onSuccess = null) {
        api.GET("/Banks", (result) => {
            if (onSuccess)
                onSuccess(result);
        });
    }
    function getOpenBankingLinkUrl(customerId) {
        return 'https://auth.truelayer.com/?response_type=code&client_id=moneyguided-cdfa82&scope=info%20accounts%20balance%20cards%20transactions%20direct_debits%20standing_orders%20offline_access&redirect_uri=' + getApiConfig().api + '/BankingGrants&providers=uk-ob-all%20uk-oauth-all&state=' + customerId;
    }
    function linkBankAccount(customerId) {
        window.location.href = getOpenBankingLinkUrl(customerId);
    }
    function addOfflineBankAccount(account, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts", account)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => addOfflineBankAccount(account, onSuccess));
            }
        });
    }
    function deleteBankAccount(id, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + id)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => deleteBankAccount(id, onSuccess));
            }
        });
    }
    function updateOfflineBankAccount(account, onSuccess = null) {
        getHttpInstance().put(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + account.id, account)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => updateOfflineBankAccount(account, onSuccess));
            }
        });
    }
    function reLinkAllBankAccounts(onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/ExtendAllConnectionsRequests", null)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => reLinkAllBankAccounts(onSuccess));
            }
        });
    }
    function getRecurringPayments(onSuccess = null, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/RecurringPayments", (result) => {
            if (onSuccess)
                onSuccess(result);
        }, !refreshCache, refreshCache);
    }
    return {
        getBankingInfo,
        clearBankingInfo,
        getBankAccount,
        listBanks,
        getOpenBankingLinkUrl,
        linkBankAccount,
        addOfflineBankAccount,
        deleteBankAccount,
        updateOfflineBankAccount,
        reLinkAllBankAccounts,
        getRecurringPayments,
    };
}
